(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-col-creadoras"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nt-col-creadoras')) {
    customElements.define(
      'nt-col-creadoras',
      class extends HTMLElement {
        connectedCallback() {
          this.lista = this.querySelector('.nt-col-cre__lista');
          this.flechas = this.querySelectorAll('.nt-col-cre__flecha');
          if (!this.lista || !this.flechas.length) return;
          this.flechas.forEach((btn) =>
            btn.addEventListener('click', () => {
              const item = this.lista.querySelector('.nt-col-cre__item');
              const paso = item ? item.getBoundingClientRect().width + 20 : this.lista.clientWidth;
              const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              this.lista.scrollBy({ left: paso * Number(btn.dataset.dir), behavior: suave ? 'smooth' : 'auto' });
            })
          );
          this.actualizar = this.actualizar.bind(this);
          this.lista.addEventListener('scroll', this.actualizar, { passive: true });
          window.addEventListener('resize', this.actualizar);
          this.actualizar();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.actualizar);
        }

        actualizar() {
          const l = this.lista;
          const fin = l.scrollWidth - l.clientWidth - 2;
          this.flechas[0].disabled = l.scrollLeft <= 2;
          this.flechas[1].disabled = l.scrollLeft >= fin;
          this.querySelector('.nt-col-cre__flechas').hidden = fin <= 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-col-guia"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nt-col-guia')) {
    customElements.define(
      'nt-col-guia',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.prod = JSON.parse(this.querySelector('[data-productos]').textContent);
            this.datos = JSON.parse(this.querySelector('[data-mapeo]').textContent);
          } catch (e) {
            return;
          }
          this.estado = { nec: 'moisture', piel: 'seca', emb: false };
          const caja = this.querySelector('[data-necesidades]');
          Object.keys(this.datos.necesidades).forEach((k) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'nt-col-guia__chip';
            b.dataset.nec = k;
            b.textContent = this.datos.necesidades[k];
            b.addEventListener('click', () => this.cambiar({ nec: k }));
            caja.appendChild(b);
          });
          this.querySelectorAll('button[data-piel]').forEach((b) => b.addEventListener('click', () => this.cambiar({ piel: b.dataset.piel })));
          const sw = this.querySelector('[data-emb]');
          sw.addEventListener('click', () => this.cambiar({ emb: !this.estado.emb }));
          this.pintar();
        }

        cambiar(c) {
          Object.assign(this.estado, c);
          this.pintar();
        }

        fila() {
          const { nec, piel, emb } = this.estado;
          const ok = (e) => {
            const t = (e || '').toLowerCase();
            if (t.indexOf('|') !== -1) return true;
            return emb ? /^s/.test(t) : t === 'no';
          };
          const pielOk = (p) => {
            const t = (p || '').toLowerCase();
            return t.indexOf('todo') !== -1 || t.indexOf(piel) !== -1;
          };
          const m = this.datos.mapeo;
          return m.find((r) => r.k === nec && ok(r.e) && pielOk(r.p)) || m.find((r) => r.k === nec && ok(r.e)) || m.find((r) => r.k === nec);
        }

        pintar() {
          const e = this.estado;
          this.querySelectorAll('button[data-nec]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.nec === e.nec)));
          this.querySelectorAll('button[data-piel]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.piel === e.piel)));
          this.querySelector('[data-emb]').setAttribute('aria-checked', String(e.emb));
          const f = this.fila();
          if (!f) return;
          this.querySelector('[data-nec-nombre]').textContent = this.datos.necesidades[e.nec] + ':';
          this.querySelector('[data-nec-desc]').textContent = f.d || '';
          [['a', f.a], ['b', f.b]].forEach(([rol, clave]) => {
            const el = this.querySelector('[data-rec="' + rol + '"]');
            const p = this.prod[clave];
            el.hidden = !p;
            if (!p) return;
            const fi = p.fichas || {};
            el.href = p.url;
            el.querySelector('[data-paso]').textContent = this.datos.pasos[clave] || '';
            el.querySelector('[data-nombre]').textContent = p.nombre;
            el.querySelector('[data-porque]').textContent = (fi.msg && fi.msg[e.nec]) || fi.gen || '';
            const img = el.querySelector('img');
            if (p.img) {
              img.src = p.img;
              img.alt = p.nombre;
              img.hidden = false;
            } else {
              img.hidden = true;
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-col-productos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nt-col-productos')) {
    customElements.define(
      'nt-col-productos',
      class extends HTMLElement {
        connectedCallback() {
          const btn = this.querySelector('[data-mas]');
          if (!btn) return;
          const etiqueta = btn.innerHTML;
          btn.addEventListener('click', () => {
            const abrir = btn.getAttribute('aria-expanded') !== 'true';
            this.querySelectorAll('[data-extra]').forEach((li) => (li.hidden = !abrir));
            btn.setAttribute('aria-expanded', String(abrir));
            btn.innerHTML = abrir ? 'Ver menos' : etiqueta;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-col-rutina"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nt-col-rutina')) {
    customElements.define(
      'nt-col-rutina',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-nav]').forEach((a) => {
            a.addEventListener('click', () => {
              this.querySelectorAll('[data-nav]').forEach((b) => b.setAttribute('aria-current', b === a ? 'true' : 'false'));
            });
          });
          this.querySelectorAll('button[data-piel]').forEach((btn) => {
            btn.addEventListener('click', () => this.filtrar(btn));
          });
        }

        filtrar(btn) {
          const piel = btn.dataset.piel;
          this.querySelectorAll('button[data-piel]').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
          this.querySelectorAll('.nt-col-tarjeta[data-piel]').forEach((t) => {
            const p = t.dataset.piel;
            t.hidden = !(piel === 'todas' || p === 'todas' || p === piel);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-col-tonos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nt-col-tonos')) {
    customElements.define(
      'nt-col-tonos',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-nav]').forEach((a) => {
            a.addEventListener('click', () => {
              this.querySelectorAll('[data-nav]').forEach((b) => b.setAttribute('aria-current', b === a ? 'true' : 'false'));
            });
          });
          const campo = this.querySelector('[data-buscar]');
          if (campo) campo.addEventListener('input', () => this.buscar(campo.value));
        }

        buscar(valor) {
          const q = valor.trim().toUpperCase().replace(/\s+/g, '');
          let total = 0;
          this.querySelectorAll('[data-familia]').forEach((fam) => {
            let visibles = 0;
            fam.querySelectorAll('li[data-codigo]').forEach((li) => {
              const ok = !q || li.dataset.codigo.indexOf(q) === 0;
              li.hidden = !ok;
              if (ok) visibles++;
            });
            fam.hidden = visibles === 0;
            total += visibles;
          });
          const vacio = this.querySelector('[data-vacio]');
          if (vacio) vacio.hidden = total > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-contacto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var motivo = new URLSearchParams(window.location.search).get('motivo');
    var campo = document.getElementById('nt-con-motivo');
    if (!motivo || !campo) return;
    var buscado = motivo.toLowerCase();
    for (var i = 0; i < campo.options.length; i++) {
      if (campo.options[i].value && campo.options[i].value.toLowerCase().indexOf(buscado) !== -1) {
        campo.selectedIndex = i;
        break;
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-emb-biblioteca"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nt-emb-temas]').forEach(function (grupo) {
      var bloque = grupo.closest('.nt-emb-bib__bloque');
      grupo.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-tema]');
        if (!b) return;
        var tema = b.getAttribute('data-tema');
        grupo.querySelectorAll('button').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        bloque.querySelectorAll('.nt-emb-bib__item').forEach(function (t) {
          t.hidden = !!tema && t.getAttribute('data-tema') !== tema;
        });
      });
    });
    function abrirAncla() {
      var h = window.location.hash;
      if (!h || h.indexOf('#pregunta-') !== 0) return;
      var d = document.getElementById(h.slice(1));
      if (d && d.tagName === 'DETAILS') d.open = true;
    }
    abrirAncla();
    window.addEventListener('hashchange', abrirAncla);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-emb-catalogo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-nt-emb-cat]');
    if (!raiz) return;
    var base = {};
    try {
      base = JSON.parse(document.querySelector('[data-nt-emb-cat-base]').textContent);
    } catch (e) {}
    var iva = (base.iva || 119) / 100;
    var tarjetas = Array.prototype.slice.call(raiz.querySelectorAll('.nt-emb-cat__tarjeta'));
    var porVariante = {};
    tarjetas.forEach(function (t) {
      porVariante[t.getAttribute('data-variante')] = t;
    });
    var raizUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ocupado = false;

    function pesos(n) {
      return '$' + Math.round(n).toLocaleString('es-CL');
    }

    function pintar(carrito) {
      var cantidades = {};
      var otros = false;
      (carrito.items || []).forEach(function (it) {
        var id = String(it.variant_id);
        // Los regalos del programa (_beneficio) los maneja assets/nt-regalos.js: no suman ni son «otros productos».
        if (it.properties && it.properties._beneficio) return;
        if (porVariante[id]) {
          cantidades[id] = (cantidades[id] || 0) + it.quantity;
        } else {
          otros = true;
        }
      });

      var total = 0;
      var totalAlma = 0;
      var lineas = raiz.querySelector('[data-lineas]');
      lineas.innerHTML = '';
      tarjetas.forEach(function (t) {
        var id = t.getAttribute('data-variante');
        var q = cantidades[id] || 0;
        var agregar = t.querySelector('[data-agregar]');
        var stepper = t.querySelector('[data-stepper]');
        if (agregar && stepper) {
          agregar.hidden = q > 0;
          stepper.hidden = q === 0;
          t.querySelector('[data-cantidad]').textContent = q;
        }
        t.classList.toggle('is-en-pedido', q > 0);
        if (q > 0) {
          var precio = parseInt(t.getAttribute('data-precio'), 10) || 0;
          total += precio * q;
          if (t.getAttribute('data-cat') === 'alma') totalAlma += precio * q;
          var li = document.createElement('li');
          var nombre = document.createElement('span');
          nombre.textContent = t.getAttribute('data-nombre') + ' × ' + q;
          var monto = document.createElement('span');
          monto.textContent = pesos(precio * q);
          li.appendChild(nombre);
          li.appendChild(monto);
          lineas.appendChild(li);
        }
      });
      if (!lineas.children.length) {
        var vacio = document.createElement('li');
        vacio.className = 'nt-emb-cat__vacio';
        vacio.textContent = 'Todavía no agregas productos.';
        lineas.appendChild(vacio);
      }

      var neto = total / iva;
      // Fase 1: la caja y los regalos cuentan solo Alma Secret (el pedido mínimo, todo el pedido).
      var netoAlma = totalAlma / iva;
      raiz.querySelector('[data-total]').textContent = pesos(total);
      raiz.querySelector('[data-neto]').textContent = pesos(neto);

      var minimo = base.minimo || 50000;
      var cajaMin = raiz.querySelector('[data-minimo]');
      var pagar = raiz.querySelector('[data-pagar]');
      if (total === 0) {
        cajaMin.className = 'nt-emb-cat__estado';
        cajaMin.textContent = 'Pedido mínimo: ' + pesos(minimo) + ' netos.';
      } else if (neto >= minimo) {
        cajaMin.className = 'nt-emb-cat__estado is-ok';
        cajaMin.textContent = '✓ Pedido mínimo de ' + pesos(minimo) + ' netos cumplido.';
      } else {
        cajaMin.className = 'nt-emb-cat__estado is-falta';
        cajaMin.textContent = 'Te faltan ' + pesos(minimo - neto) + ' netos para el pedido mínimo de ' + pesos(minimo) + '.';
      }
      var listo = total > 0 && neto >= minimo;
      pagar.setAttribute('aria-disabled', listo ? 'false' : 'true');
      pagar.classList.toggle('is-listo', listo);

      raiz.querySelector('[data-otros]').hidden = !otros;

      var cajaTexto = raiz.querySelector('[data-caja-texto]');
      if (cajaTexto) {
        var caja = base.caja || 100000;
        var conPedido = (base.acum || 0) + netoAlma;
        var pct = Math.min(100, Math.round((conPedido * 100) / caja));
        raiz.querySelector('[data-caja-barra]').style.width = pct + '%';
        if ((base.acum || 0) >= caja) {
          cajaTexto.textContent = 'Ya completaste tu caja. La recibes con tu próximo pedido o al retirarlo en Las Condes.';
        } else if (conPedido >= caja) {
          cajaTexto.textContent = 'Con este pedido completas tu caja de bienvenida.';
        } else {
          cajaTexto.textContent = 'Con este pedido llevas ' + pesos(conPedido) + ' netos en Alma Secret. Te faltan ' + pesos(caja - conPedido) + ' para tu caja.';
        }
      }

      var metaTexto = raiz.querySelector('[data-meta-texto]');
      if (metaTexto) {
        var metas = base.metas || [];
        if (!base.metasActivas) {
          metaTexto.textContent = base.antesMetas || 'Los regalos por compras parten en enero.';
        } else if ((base.pagadas || 0) < 1) {
          metaTexto.textContent = 'Los regalos por compras cuentan desde tu segunda compra.';
        } else {
          var mes = (base.mesMetas || 0) + netoAlma;
          var lograda = 0;
          var siguiente = null;
          metas.forEach(function (m, i) {
            if (mes >= m.monto) {
              lograda = i + 1;
            } else if (!siguiente) {
              siguiente = { n: i + 1, monto: m.monto, premio: m.premio };
            }
          });
          var txt = '';
          if (lograda > 0) txt = 'Con este pedido ya tienes regalo este mes: ' + metas[lograda - 1].premio + '. ';
          if (siguiente) {
            txt += 'Te faltan ' + pesos(siguiente.monto - mes) + ' netos para ' + (lograda > 0 ? 'el siguiente regalo' : 'tu regalo del mes') + ': ' + siguiente.premio + '.';
          } else if (metas.length) {
            txt += 'Es el regalo más alto del mes.';
          }
          metaTexto.textContent = txt;
        }
      }
    }

    function leer() {
      return fetch(raizUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    }

    function cambiar(id, cantidad, sumar) {
      if (ocupado) return;
      ocupado = true;
      raiz.classList.add('is-ocupado');
      var url = sumar ? 'cart/add.js' : 'cart/update.js';
      var cuerpo = sumar
        ? { items: [{ id: parseInt(id, 10), quantity: cantidad }] }
        : { updates: (function () { var u = {}; u[id] = cantidad; return u; })() };
      fetch(raizUrl + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (e) {
              throw new Error(e.description || e.message || 'No se pudo actualizar tu pedido.');
            });
          }
          return r.json();
        })
        .then(leer)
        .then(function (c) {
          pintar(c);
          avisarAlTema(c, id, cantidad, sumar);
        })
        .catch(function (e) {
          window.alert(e.message);
        })
        .then(function () {
          ocupado = false;
          raiz.classList.remove('is-ocupado');
        });
    }

    raiz.addEventListener('click', function (e) {
      var t = e.target.closest('.nt-emb-cat__tarjeta');
      var filtro = e.target.closest('.nt-emb-cat__filtro');
      if (filtro) {
        var cat = filtro.getAttribute('data-cat');
        raiz.querySelectorAll('.nt-emb-cat__filtro').forEach(function (b) {
          b.setAttribute('aria-pressed', b === filtro ? 'true' : 'false');
        });
        tarjetas.forEach(function (x) {
          x.hidden = !!cat && x.getAttribute('data-cat') !== cat;
        });
        raiz.querySelectorAll('.nt-emb-cat__grupo').forEach(function (g) {
          g.hidden = !!cat && g.getAttribute('data-grupo') !== cat;
        });
        return;
      }
      var pagar = e.target.closest('[data-pagar]');
      if (pagar && pagar.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        var aviso = raiz.querySelector('[data-minimo]');
        aviso.classList.add('is-destacado');
        setTimeout(function () { aviso.classList.remove('is-destacado'); }, 1200);
        return;
      }
      if (!t) return;
      var id = t.getAttribute('data-variante');
      var actual = parseInt(t.querySelector('[data-cantidad]') ? t.querySelector('[data-cantidad]').textContent : '0', 10) || 0;
      if (e.target.closest('[data-agregar]')) cambiar(id, 1, true);
      if (e.target.closest('[data-mas]')) cambiar(id, actual + 1, false);
      if (e.target.closest('[data-menos]')) cambiar(id, Math.max(0, actual - 1), false);
    });

    // Avisa al ícono del carrito y al carrito lateral del tema (Horizon escucha el evento estándar
    // shopify:cart:lines-update). Sin esto, el ícono seguía en 0 hasta recargar la página.
    function avisarAlTema(carrito, id, cantidad, sumar) {
      import('@shopify/events')
        .then(function (m) {
          var Evento = m.CartLinesUpdateEvent;
          var diferido = Evento.createPromise();
          raiz.dispatchEvent(
            new Evento({
              action: sumar ? 'add' : cantidad === 0 ? 'remove' : 'update',
              context: 'product',
              lines: [{ merchandiseId: String(id), quantity: cantidad }],
              promise: diferido.promise
            })
          );
          diferido.resolve({
            cart: Evento.createCartFromAjaxResponse(carrito),
            detail: { source: 'nt-emb-catalogo', itemCount: carrito.item_count, didError: false }
          });
        })
        .catch(function (e) {
          console.warn('[nt-emb-catalogo] No se pudo avisar al carrito del tema:', e);
        });
    }

    // Si el carrito cambia desde otro lugar (por ejemplo, el carrito lateral), el pedido se actualiza.
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.target === raiz || raiz.contains(e.target)) return;
      var listo = e.promise && typeof e.promise.then === 'function' ? e.promise : Promise.resolve();
      listo.then(leer).then(pintar).catch(function () {});
    });

    leer().then(pintar).catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-emb-panel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nt-emb-filtros]').forEach(function (grupo) {
      var seccion = grupo.closest('.nt-emb-panel');
      grupo.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-tipo]');
        if (!b) return;
        var tipo = b.getAttribute('data-tipo');
        grupo.querySelectorAll('button').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        seccion.querySelectorAll('.nt-emb-panel__tarjeta').forEach(function (t) {
          t.hidden = !!tipo && t.getAttribute('data-tipo') !== tipo;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-ficha-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nt-ficha-producto')) return;

    class NtFichaProducto extends HTMLElement {
      connectedCallback() {
        this.ruta();
        this.galeria();
        this.variantes();
        this.compra();
      }

      ruta() {
        var desde = new URLSearchParams(window.location.search).get('desde');
        var mapa = { catalogo: 'catalogo', pedido: 'pedido', coleccion: 'coleccion' };
        var elegida = mapa[desde];
        if (elegida) {
          this.querySelectorAll('[data-ruta]').forEach(function (r) {
            r.hidden = r.getAttribute('data-ruta') !== elegida;
          });
          document.querySelectorAll('[data-conservar-desde]').forEach(function (a) {
            try {
              var u = new URL(a.href, window.location.origin);
              u.searchParams.set('desde', desde);
              a.href = u.pathname + u.search + u.hash;
            } catch (e) {}
          });
        }
      }

      galeria() {
        var raiz = this.querySelector('[data-galeria]');
        if (!raiz) return;
        var video = raiz.querySelector('[data-panel="video"] video');
        if (video) {
          video.muted = true;
          video.loop = true;
          video.setAttribute('playsinline', '');
          video.removeAttribute('controls');
        }
        var mostrar = function (cual) {
          raiz.querySelectorAll('[data-panel]').forEach(function (p) {
            p.hidden = p.getAttribute('data-panel') !== cual;
          });
          raiz.querySelectorAll('.nt-ficha-pro__mini').forEach(function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-ver') === cual ? 'true' : 'false');
          });
          raiz.classList.toggle('is-video', cual === 'video');
          if (video) {
            if (cual === 'video') {
              var promesa = video.play();
              if (promesa && promesa.catch) promesa.catch(function () {});
            } else {
              video.pause();
            }
          }
        };
        raiz.addEventListener('click', function (e) {
          var b = e.target.closest('[data-ver]');
          if (b) mostrar(b.getAttribute('data-ver'));
        });
      }

      variantes() {
        var self = this;
        this.querySelectorAll('[data-variante]').forEach(function (r) {
          r.addEventListener('change', function () {
            self.querySelectorAll('[data-panel-variante]').forEach(function (p) {
              p.hidden = p.getAttribute('data-panel-variante') !== r.value;
            });
            var estado = self.querySelector('[data-estado]');
            if (estado) estado.hidden = true;
          });
        });
      }

      compra() {
        var self = this;
        var raizUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.querySelectorAll('[data-agregar-form]').forEach(function (form) {
          var campo = form.querySelector('[data-cantidad]');
          form.addEventListener('click', function (e) {
            var menos = e.target.closest('[data-menos]');
            var mas = e.target.closest('[data-mas]');
            if (!menos && !mas) return;
            var n = parseInt(campo.value, 10) || 1;
            n = menos ? Math.max(1, n - 1) : Math.min(999, n + 1);
            campo.value = n;
          });
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            var boton = form.querySelector('[data-agregar]');
            var estado = self.querySelector('[data-estado]');
            var id = parseInt(form.querySelector('[name="id"]').value, 10);
            var cantidad = Math.max(1, parseInt(campo.value, 10) || 1);
            boton.disabled = true;
            fetch(raizUrl + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: id, quantity: cantidad }] })
            })
              .then(function (r) {
                return r.json().then(function (d) {
                  if (!r.ok) throw new Error(d.description || d.message || 'No se pudo agregar a tu pedido.');
                  return d;
                });
              })
              .then(function () {
                return fetch(raizUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
                  return r.json();
                });
              })
              .then(function (carrito) {
                self.avisar(estado, 'ok', cantidad);
                self.avisarAlTema(carrito, [{ merchandiseId: String(id), quantity: cantidad }]);
              })
              .catch(function (err) {
                self.avisar(estado, 'error', 0, err.message);
              })
              .then(function () {
                boton.disabled = false;
              });
          });
        });
      }

      avisar(estado, tipo, cantidad, mensaje) {
        if (!estado) return;
        estado.hidden = false;
        estado.classList.toggle('is-error', tipo === 'error');
        estado.textContent = '';
        if (tipo === 'error') {
          estado.textContent = mensaje;
          return;
        }
        var vista = this.getAttribute('data-vista');
        var enlace = this.querySelector('[data-ruta="' + (vista === 'emb' ? 'catalogo' : 'pedido') + '"] .nt-ficha-pro__volver');
        estado.append(document.createTextNode(cantidad === 1 ? 'Agregaste 1 unidad a tu pedido. ' : 'Agregaste ' + cantidad + ' unidades a tu pedido. '));
        if (enlace) {
          var a = document.createElement('a');
          a.href = enlace.getAttribute('href');
          a.textContent = 'Ver tu pedido →';
          estado.append(a);
        }
      }

      avisarAlTema(carrito, lineas) {
        var raiz = this;
        import('@shopify/events')
          .then(function (m) {
            var Evento = m.CartLinesUpdateEvent;
            var diferido = Evento.createPromise();
            raiz.dispatchEvent(new Evento({ action: 'add', context: 'product', lines: lineas, promise: diferido.promise }));
            diferido.resolve({
              cart: Evento.createCartFromAjaxResponse(carrito),
              detail: { source: 'nt-ficha-producto', itemCount: carrito.item_count, didError: false }
            });
          })
          .catch(function () {});
      }
    }

    customElements.define('nt-ficha-producto', NtFichaProducto);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-postulacion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tipo = new URLSearchParams(window.location.search).get('tipo');
    if (!tipo) return;
    var opcion = document.querySelector('.nt-postulacion [data-nt-tipo="' + tipo + '"]');
    if (opcion) opcion.checked = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-sol-formulario"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var CAMPOS = {
      nombre: 'Nombre',
      apellidos: 'Apellidos',
      rut: 'RUT',
      correo: 'Correo',
      whatsapp: 'WhatsApp',
      pais: 'País',
      desayuno: 'Desayuno al que asististe',
      referida: '¿Alguien te recomendó el programa?',
      razonSocial: 'Razón social',
      rutEmpresa: 'RUT de la empresa',
      giro: 'Giro',
      direccionComercial: 'Dirección comercial'
    };

    function norm(t) {
      return (t || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[*:¿?]/g, '')
        .replace(/\(opcional\)/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function controlDe(etiqueta) {
      if (etiqueta.htmlFor) {
        var porId = document.getElementById(etiqueta.htmlFor);
        if (porId) return porId;
      }
      var dentro = etiqueta.querySelector('input:not([type=hidden]), select, textarea');
      if (dentro) return dentro;
      var nodo = etiqueta.parentElement;
      for (var i = 0; i < 3 && nodo; i++) {
        var c = nodo.querySelector('input:not([type=hidden]):not([type=radio]):not([type=checkbox]), select, textarea');
        if (c) return c;
        nodo = nodo.parentElement;
      }
      return null;
    }

    function buscar(form, texto) {
      var clave = norm(texto);
      var etiquetas = form.querySelectorAll('label, legend');
      var exacta = null;
      var parcial = null;
      for (var i = 0; i < etiquetas.length; i++) {
        if (etiquetas[i].classList.contains('radio-label') || etiquetas[i].classList.contains('checkbox-label')) continue;
        var t = norm(etiquetas[i].textContent);
        if (t === clave && !exacta) exacta = etiquetas[i];
        else if (t.indexOf(clave) === 0 && !parcial) parcial = etiquetas[i];
      }
      var elegida = exacta || parcial;
      if (elegida) return controlDe(elegida);
      var todos = form.querySelectorAll('input, select, textarea');
      for (var j = 0; j < todos.length; j++) {
        var a = norm(todos[j].getAttribute('aria-label') || todos[j].getAttribute('placeholder'));
        if (a && a.indexOf(clave) === 0) return todos[j];
      }
      return null;
    }

    function caja(control) {
      return (
        control.closest('.samitaWS-registrationForm-control, [class*="field"], [class*="form-item"], [class*="form-group"]') ||
        control.parentElement
      );
    }

    function fijar(control, valor) {
      var proto =
        control.tagName === 'SELECT'
          ? HTMLSelectElement.prototype
          : control.tagName === 'TEXTAREA'
          ? HTMLTextAreaElement.prototype
          : HTMLInputElement.prototype;
      var setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
      setter.call(control, valor);
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function marcar(control, mensaje) {
      var contenedor = caja(control);
      var aviso = contenedor.querySelector('.nt-sol-form__error');
      if (!mensaje) {
        if (aviso) aviso.remove();
        control.removeAttribute('aria-invalid');
        return true;
      }
      if (!aviso) {
        aviso = document.createElement('p');
        aviso.className = 'nt-sol-form__error';
        aviso.id = 'nt-err-' + Math.random().toString(36).slice(2, 8);
        aviso.setAttribute('role', 'alert');
        contenedor.appendChild(aviso);
      }
      aviso.textContent = mensaje;
      control.setAttribute('aria-invalid', 'true');
      var desc = control.getAttribute('aria-describedby') || '';
      if (desc.indexOf(aviso.id) < 0) control.setAttribute('aria-describedby', (desc + ' ' + aviso.id).trim());
      return false;
    }

    function rutLimpio(v) {
      return (v || '').replace(/[^0-9kK]/g, '').toUpperCase();
    }

    function rutValido(v) {
      var r = rutLimpio(v);
      if (r.length < 8 || r.length > 9) return false;
      var cuerpo = r.slice(0, -1);
      var dv = r.slice(-1);
      if (!/^\d+$/.test(cuerpo)) return false;
      var suma = 0;
      var m = 2;
      for (var i = cuerpo.length - 1; i >= 0; i--) {
        suma += parseInt(cuerpo.charAt(i), 10) * m;
        m = m === 7 ? 2 : m + 1;
      }
      var res = 11 - (suma % 11);
      var esperado = res === 11 ? '0' : res === 10 ? 'K' : String(res);
      return esperado === dv;
    }

    function rutNormal(v) {
      var r = rutLimpio(v);
      return r.slice(0, -1) + '-' + r.slice(-1);
    }

    function fonoNormal(v) {
      var d = (v || '').replace(/\D/g, '');
      if (d.indexOf('56') === 0 && d.length === 11) d = d.slice(2);
      if (d.length === 8) d = '9' + d;
      return /^9\d{8}$/.test(d) ? '+56' + d : null;
    }

    function radioFactura(form) {
      var radios = form.querySelectorAll('input[type=radio]');
      for (var i = 0; i < radios.length; i++) {
        var lbl = radios[i].closest('label') || form.querySelector('label[for="' + CSS.escape(radios[i].id) + '"]');
        var t = norm((lbl && lbl.textContent) || radios[i].value);
        if (t.indexOf('factura') === 0) return radios[i];
      }
      return null;
    }

    function textoBoton(form, texto) {
      if (!texto) return;
      var b = form.querySelector('button.submit, button[type=submit], input[type=submit]');
      if (!b) return;
      if (b.tagName === 'INPUT') {
        if (/^\s*submit\s*$/i.test(b.value)) b.value = texto;
        return;
      }
      var nodos = b.childNodes;
      for (var i = nodos.length - 1; i >= 0; i--) {
        if (nodos[i].nodeType === 3 && /\S/.test(nodos[i].nodeValue)) {
          if (/^\s*submit\s*$/i.test(nodos[i].nodeValue)) nodos[i].nodeValue = ' ' + texto + ' ';
          return;
        }
      }
    }

    function iniciar(form, raiz) {
      if (form.dataset.ntSol === '1') return;
      var f = {};
      Object.keys(CAMPOS).forEach(function (k) {
        f[k] = buscar(form, CAMPOS[k]);
      });
      if (!f.rut && !f.correo) return;
      form.dataset.ntSol = '1';

      if (f.nombre) f.nombre.setAttribute('autocomplete', 'given-name');
      if (f.apellidos) f.apellidos.setAttribute('autocomplete', 'family-name');
      if (f.correo) {
        f.correo.setAttribute('autocomplete', 'email');
        f.correo.setAttribute('inputmode', 'email');
        f.correo.setAttribute('spellcheck', 'false');
        f.correo.setAttribute('autocapitalize', 'off');
      }
      if (f.whatsapp) {
        f.whatsapp.setAttribute('autocomplete', 'tel');
        f.whatsapp.setAttribute('inputmode', 'tel');
      }
      if (f.rut) f.rut.setAttribute('autocomplete', 'off');
      if (f.pais) caja(f.pais).hidden = true;
      textoBoton(form, raiz.getAttribute('data-boton'));

      // Precarga desde el enlace de invitación
      var params = new URLSearchParams(window.location.search);
      var desayuno = norm(params.get('desayuno'));
      if (desayuno && f.desayuno && f.desayuno.tagName === 'SELECT') {
        var buscado = desayuno === 'no' ? 'no asisti' : 'desayuno ' + desayuno;
        for (var i = 0; i < f.desayuno.options.length; i++) {
          if (norm(f.desayuno.options[i].text).indexOf(buscado) === 0) {
            fijar(f.desayuno, f.desayuno.options[i].value);
            break;
          }
        }
      }
      var ref = params.get('ref');
      if (ref && f.referida && !f.referida.value) fijar(f.referida, ref.slice(0, 60));

      // Datos de factura: Sami los muestra solo con "Factura"; aquí se exigen en ese caso
      var factura = radioFactura(form);
      var camposFactura = [f.razonSocial, f.rutEmpresa, f.giro, f.direccionComercial].filter(Boolean);
      function esFactura() {
        return !!(factura && factura.checked);
      }
      function actualizarFactura() {
        var on = esFactura();
        camposFactura.forEach(function (c) {
          var etiqueta = caja(c).querySelector('label.samitaWS-label');
          if (etiqueta && !etiqueta.querySelector('.nt-sol-form__req')) {
            var ast = document.createElement('span');
            ast.className = 'text-danger text-smaller nt-sol-form__req';
            ast.textContent = ' *';
            etiqueta.appendChild(ast);
          }
          if (on) c.setAttribute('aria-required', 'true');
          else {
            c.removeAttribute('aria-required');
            marcar(c, null);
          }
        });
      }
      if (factura && camposFactura.length) {
        form.addEventListener('change', function (e) {
          if (e.target && e.target.type === 'radio') actualizarFactura();
        });
        actualizarFactura();
      }

      // Formato al salir del campo
      if (f.rut) {
        f.rut.addEventListener('blur', function () {
          if (rutValido(f.rut.value)) {
            fijar(f.rut, rutNormal(f.rut.value));
            marcar(f.rut, null);
          }
        });
      }
      if (f.whatsapp) {
        f.whatsapp.addEventListener('blur', function () {
          var n = fonoNormal(f.whatsapp.value);
          if (n) {
            fijar(f.whatsapp, n);
            marcar(f.whatsapp, null);
          }
        });
      }

      function validar(evento) {
        var errores = [];
        if (f.rut) {
          if (!f.rut.value.trim()) errores.push([f.rut, 'Ingresa tu RUT.']);
          else if (!rutValido(f.rut.value)) errores.push([f.rut, 'Revisa tu RUT: el dígito verificador no coincide. Ejemplo: 12.345.678-9.']);
          else {
            fijar(f.rut, rutNormal(f.rut.value));
            marcar(f.rut, null);
          }
        }
        if (f.whatsapp) {
          var n = fonoNormal(f.whatsapp.value);
          if (!n) errores.push([f.whatsapp, 'Revisa tu WhatsApp: debe ser un celular chileno, por ejemplo +56 9 1234 5678.']);
          else {
            fijar(f.whatsapp, n);
            marcar(f.whatsapp, null);
          }
        }
        if (esFactura()) {
          camposFactura.forEach(function (c) {
            if (!c.value.trim()) errores.push([c, 'Este dato es necesario para emitir tu factura.']);
            else marcar(c, null);
          });
          if (f.rutEmpresa && f.rutEmpresa.value.trim()) {
            if (!rutValido(f.rutEmpresa.value)) errores.push([f.rutEmpresa, 'Revisa el RUT de la empresa. Ejemplo: 76.123.456-7.']);
            else fijar(f.rutEmpresa, rutNormal(f.rutEmpresa.value));
          }
        }
        if (!errores.length) return true;
        errores.forEach(function (e) {
          marcar(e[0], e[1]);
        });
        evento.preventDefault();
        evento.stopImmediatePropagation();
        errores[0][0].focus();
        return false;
      }

      form.addEventListener('submit', validar, true);
      form.addEventListener(
        'click',
        function (e) {
          var b = e.target.closest('button, input[type=submit]');
          if (!b) return;
          if (b.type === 'submit' || b.classList.contains('submit')) validar(e);
        },
        true
      );
    }

    function revisar(raiz) {
      raiz.querySelectorAll('form').forEach(function (form) {
        iniciar(form, raiz);
      });
    }

    document.querySelectorAll('[data-nt-sol-form]').forEach(function (raiz) {
      revisar(raiz);
      new MutationObserver(function () {
        revisar(raiz);
      }).observe(raiz, { childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-sol-solicitud"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function norm(t) {
      return (t || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function iniciarPasos(lista) {
      var raiz = lista.closest('.nt-sol-solicitud');
      if (!raiz) return;
      var pasos = Array.prototype.slice.call(lista.querySelectorAll('.nt-sol-solicitud__paso'));
      if (!pasos.length) return;

      function destinos() {
        var app = raiz.querySelector('[data-nt-sol-form]');
        var titulos = app ? app.querySelectorAll('h1, h2, h3, h4, legend') : [];
        return pasos.map(function (paso, i) {
          var clave = norm(paso.getAttribute('data-titulo'));
          if (!clave) return i === 0 ? app : null;
          for (var j = 0; j < titulos.length; j++) {
            if (norm(titulos[j].textContent) === clave) return titulos[j];
          }
          return null;
        });
      }

      var pendiente = false;
      function marcar() {
        pendiente = false;
        var lista = destinos();
        var limite = window.innerHeight * 0.4;
        var actual = 0;
        lista.forEach(function (el, i) {
          if (el && el.getBoundingClientRect().top < limite) actual = i;
        });
        pasos.forEach(function (paso, i) {
          paso.classList.toggle('is-hecho', i < actual);
          paso.classList.toggle('is-actual', i === actual);
          if (i === actual) paso.setAttribute('aria-current', 'step');
          else paso.removeAttribute('aria-current');
        });
      }

      window.addEventListener(
        'scroll',
        function () {
          if (pendiente) return;
          pendiente = true;
          window.requestAnimationFrame(marcar);
        },
        { passive: true }
      );
      marcar();
    }

    function arrancar() {
      document.querySelectorAll('[data-nt-sol-pasos]').forEach(iniciarPasos);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-tienda-cuenta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-nt-tie-cta]');
    if (!raiz) return;
    var raizUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Material de apoyo: pestañas por marca.
    var tabs = Array.prototype.slice.call(raiz.querySelectorAll('[data-mat]'));
    function ver(cual, foco) {
      tabs.forEach(function (t) {
        var activa = t.getAttribute('data-mat') === cual;
        t.setAttribute('aria-selected', activa ? 'true' : 'false');
        t.tabIndex = activa ? 0 : -1;
        if (activa && foco) t.focus();
      });
      raiz.querySelectorAll('[data-mat-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-mat-panel') !== cual;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        ver(t.getAttribute('data-mat'));
      });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        ver(tabs[(i + 1) % tabs.length].getAttribute('data-mat'), true);
      });
    });

    // Repetir un pedido: vuelve a poner sus productos en el carrito y lleva a «Arma tu pedido».
    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-repetir]');
      if (!b || b.disabled) return;
      var items = b
        .getAttribute('data-repetir')
        .split(',')
        .filter(Boolean)
        .map(function (par) {
          var p = par.split(':');
          return { id: parseInt(p[0], 10), quantity: parseInt(p[1], 10) || 1 };
        });
      if (!items.length) return;
      b.disabled = true;
      var texto = b.textContent;
      b.textContent = 'Agregando…';
      fetch(raizUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (er) {
              throw new Error(er.description || er.message || 'No pudimos repetir el pedido.');
            });
          }
          window.location.href = raiz.getAttribute('data-pedido-url') + '#todos';
        })
        .catch(function (er) {
          window.alert(er.message);
          b.disabled = false;
          b.textContent = texto;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-tienda-pedido"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-nt-tie-ped]');
    if (!raiz) return;
    var base = {};
    try {
      base = JSON.parse(document.querySelector('[data-nt-tie-ped-base]').textContent);
    } catch (e) {}
    var factor = (base.factor || 70) / 100;
    var iva = (base.iva || 119) / 100;
    var minimo = base.minimo || 100000;
    var umbralMayorista = base.mayorista || 250000;
    var raizUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ocupado = false;

    var items = Array.prototype.slice.call(raiz.querySelectorAll('[data-item]'));
    var porVariante = {};
    items.forEach(function (it) {
      porVariante[it.getAttribute('data-variante')] = it;
    });
    var carritoActual = {};

    function pesos(n) {
      return '$' + Math.round(n).toLocaleString('es-CL');
    }
    function netoDe(pvp) {
      return Math.round((pvp * factor) / iva);
    }
    function pvpNetoDe(pvp) {
      return Math.round(pvp / iva);
    }

    /* ---------- Pestañas ---------- */
    var pestanas = Array.prototype.slice.call(raiz.querySelectorAll('[data-tab]'));
    function verPestana(cual, foco) {
      pestanas.forEach(function (b) {
        var activa = b.getAttribute('data-tab') === cual;
        b.setAttribute('aria-selected', activa ? 'true' : 'false');
        b.tabIndex = activa ? 0 : -1;
        if (activa && foco) b.focus();
      });
      raiz.querySelectorAll('[data-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== cual;
      });
    }
    pestanas.forEach(function (b, i) {
      b.addEventListener('click', function () {
        verPestana(b.getAttribute('data-tab'));
      });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var otra = pestanas[(i + (e.key === 'ArrowRight' ? 1 : pestanas.length - 1)) % pestanas.length];
        verPestana(otra.getAttribute('data-tab'), true);
      });
    });
    if (/sugerencia/.test(window.location.hash)) verPestana('sugerencia');
    if (/todos/.test(window.location.hash)) verPestana('todos');
    verPestana(raiz.querySelector('[data-tab][aria-selected="true"]').getAttribute('data-tab'));

    /* ---------- Filtros ---------- */
    var filtro = { marca: '', cat: '', fam: '', texto: '' };
    var cuentaTotal = raiz.querySelector('[data-total-productos]');
    if (cuentaTotal) cuentaTotal.textContent = '· ' + items.length;
    raiz.querySelectorAll('[data-cuenta]').forEach(function (c) {
      var cat = c.getAttribute('data-cuenta');
      c.textContent = items.filter(function (it) {
        return !cat || it.getAttribute('data-cat') === cat;
      }).length;
    });

    function aplicarFiltros() {
      var texto = filtro.texto.trim().toLowerCase();
      var visibles = 0;
      items.forEach(function (it) {
        var ok =
          (!filtro.marca || it.getAttribute('data-marca') === filtro.marca) &&
          (!filtro.cat || it.getAttribute('data-cat') === filtro.cat) &&
          (!filtro.fam || it.getAttribute('data-fam') === filtro.fam) &&
          (!texto || (it.getAttribute('data-buscar') || '').indexOf(texto) !== -1);
        it.hidden = !ok;
        if (ok) visibles++;
      });
      raiz.querySelectorAll('[data-grupo]').forEach(function (g) {
        g.hidden = !g.querySelector('[data-item]:not([hidden])');
      });
      raiz.querySelectorAll('[data-cat][data-de]').forEach(function (c) {
        c.hidden = !!filtro.marca && c.getAttribute('data-de') !== filtro.marca;
      });
      raiz.querySelector('[data-familias]').hidden = filtro.cat !== 'tintura';
      raiz.querySelector('[data-sin-resultados]').hidden = visibles > 0;
    }
    function marcar(selector, valor, atributo) {
      raiz.querySelectorAll(selector).forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute(atributo) === valor ? 'true' : 'false');
      });
    }
    raiz.querySelectorAll('[data-marca]').forEach(function (b) {
      if (b.hasAttribute('data-item')) return;
      b.addEventListener('click', function () {
        filtro.marca = b.getAttribute('data-marca');
        filtro.cat = '';
        filtro.fam = '';
        marcar('button[data-marca]', filtro.marca, 'data-marca');
        marcar('button[data-cat]', '', 'data-cat');
        marcar('button[data-fam]', '', 'data-fam');
        aplicarFiltros();
      });
    });
    raiz.querySelectorAll('button[data-cat]').forEach(function (b) {
      b.addEventListener('click', function () {
        filtro.cat = b.getAttribute('data-cat');
        filtro.fam = '';
        marcar('button[data-cat]', filtro.cat, 'data-cat');
        marcar('button[data-fam]', '', 'data-fam');
        aplicarFiltros();
      });
    });
    raiz.querySelectorAll('button[data-fam]').forEach(function (b) {
      b.addEventListener('click', function () {
        filtro.fam = b.getAttribute('data-fam');
        marcar('button[data-fam]', filtro.fam, 'data-fam');
        aplicarFiltros();
      });
    });
    var buscar = raiz.querySelector('[data-buscador]');
    if (buscar) {
      buscar.addEventListener('input', function () {
        filtro.texto = buscar.value;
        aplicarFiltros();
      });
    }
    raiz.querySelector('[data-limpiar]').addEventListener('click', function () {
      filtro = { marca: '', cat: '', fam: '', texto: '' };
      if (buscar) buscar.value = '';
      marcar('button[data-marca]', '', 'data-marca');
      marcar('button[data-cat]', '', 'data-cat');
      marcar('button[data-fam]', '', 'data-fam');
      aplicarFiltros();
    });

    /* ---------- Sugerencia (borrador que se ajusta con + y −) ---------- */
    var bloquesSug = Array.prototype.slice.call(raiz.querySelectorAll('[data-sug]'));
    function itemsSug(bloque) {
      return Array.prototype.slice.call(bloque.querySelectorAll('[data-sug-item]:not([data-agotado])'));
    }
    function cantidadSug(it) {
      var c = it.querySelector('[data-sug-cantidad]');
      return c ? parseInt(c.textContent, 10) || 0 : 0;
    }
    function pintarSugerencia() {
      bloquesSug.forEach(function (bloque) {
        var neto = 0;
        var cajas = 0;
        var cuidado = 0;
        var productos = 0;
        var igual = true;
        var alguno = false;
        itemsSug(bloque).forEach(function (it) {
          var q = cantidadSug(it);
          var id = it.getAttribute('data-variante');
          neto += netoDe(parseInt(it.getAttribute('data-pvp'), 10) || 0) * q;
          var tipo = it.getAttribute('data-tipo');
          if (tipo === 'caja') cajas += q;
          else if (tipo === 'cuidado') cuidado += q;
          else productos += q;
          if ((carritoActual[id] || 0) !== q) igual = false;
          if ((carritoActual[id] || 0) > 0) alguno = true;
        });
        var resumen = '';
        if (bloque.getAttribute('data-sug') === 'herb') {
          resumen = 'Herbatint: ' + cajas + (cajas === 1 ? ' caja' : ' cajas') + ' y ' + cuidado + (cuidado === 1 ? ' producto' : ' productos') + ' de cuidado';
        } else {
          resumen = 'Alma Secret: ' + productos + (productos === 1 ? ' producto' : ' productos');
        }
        bloque.querySelector('[data-sug-resumen]').textContent = resumen;
        bloque.querySelector('[data-sug-neto]').textContent = pesos(neto);
        var boton = bloque.querySelector('[data-sug-agregar]');
        var nombre = bloque.getAttribute('data-sug') === 'herb' ? 'Herbatint' : 'Alma Secret';
        boton.textContent = igual ? 'En tu pedido ✓' : alguno ? 'Actualizar en tu pedido' : 'Agregar ' + nombre + ' al pedido';
        boton.classList.toggle('is-listo', igual);
      });
    }
    raiz.querySelectorAll('[data-sug-item]').forEach(function (it) {
      var c = it.querySelector('[data-sug-cantidad]');
      if (!c) return;
      it.querySelector('[data-sug-menos]').addEventListener('click', function () {
        c.textContent = Math.max(0, cantidadSug(it) - 1);
        pintarSugerencia();
      });
      it.querySelector('[data-sug-mas]').addEventListener('click', function () {
        c.textContent = cantidadSug(it) + 1;
        pintarSugerencia();
      });
    });
    bloquesSug.forEach(function (bloque) {
      bloque.querySelector('[data-sug-agregar]').addEventListener('click', function () {
        var updates = {};
        var hay = false;
        itemsSug(bloque).forEach(function (it) {
          updates[it.getAttribute('data-variante')] = cantidadSug(it);
          hay = true;
        });
        if (hay) actualizar(updates);
      });
    });

    /* ---------- Carrito ---------- */
    function pintar(carrito) {
      var cantidades = {};
      var otros = false;
      (carrito.items || []).forEach(function (it) {
        var id = String(it.variant_id);
        if (porVariante[id] || raiz.querySelector('[data-sug-item][data-variante="' + id + '"]')) {
          cantidades[id] = (cantidades[id] || 0) + it.quantity;
        } else {
          otros = true;
        }
      });
      carritoActual = cantidades;

      var marcas = { alma: { nombre: 'Alma Secret', u: 0, p: 0, neto: 0 }, herbatint: { nombre: 'Herbatint', u: 0, p: 0, neto: 0 } };
      var neto = 0;
      var margen = 0;
      items.forEach(function (it) {
        var id = it.getAttribute('data-variante');
        var q = cantidades[id] || 0;
        var agregar = it.querySelector('[data-agregar]');
        var stepper = it.querySelector('[data-stepper]');
        if (agregar && stepper) {
          agregar.hidden = q > 0;
          stepper.hidden = q === 0;
          stepper.querySelector('[data-cantidad]').textContent = q;
        }
        it.classList.toggle('is-en-pedido', q > 0);
        if (q > 0) {
          var pvp = parseInt(it.getAttribute('data-pvp'), 10) || 0;
          var n = netoDe(pvp) * q;
          var m = marcas[it.getAttribute('data-marca')];
          m.u += q;
          m.p += 1;
          m.neto += n;
          neto += n;
          margen += (pvpNetoDe(pvp) - netoDe(pvp)) * q;
        }
      });

      var resumen = raiz.querySelector('[data-resumen]');
      resumen.innerHTML = '';
      ['alma', 'herbatint'].forEach(function (k) {
        var m = marcas[k];
        if (!m.u) return;
        var fila = document.createElement('p');
        var izq = document.createElement('span');
        var nombre = document.createElement('strong');
        nombre.textContent = m.nombre;
        var detalle = document.createElement('span');
        detalle.textContent = m.u + (m.u === 1 ? ' unidad' : ' unidades') + ' · ' + m.p + (m.p === 1 ? ' producto' : ' productos');
        izq.appendChild(nombre);
        izq.appendChild(detalle);
        var der = document.createElement('span');
        der.textContent = pesos(m.neto);
        fila.appendChild(izq);
        fila.appendChild(der);
        resumen.appendChild(fila);
      });
      var hay = neto > 0;
      resumen.hidden = !hay;
      raiz.querySelector('[data-vacio]').hidden = hay;
      raiz.querySelector('[data-totales]').hidden = !hay;
      raiz.querySelector('[data-margen-caja]').hidden = !hay;
      raiz.querySelector('[data-neto]').textContent = pesos(neto);
      raiz.querySelector('[data-iva]').textContent = pesos(neto * (iva - 1));
      raiz.querySelector('[data-total]').textContent = pesos(neto * iva);
      raiz.querySelector('[data-margen]').textContent = pesos(margen);

      var ok = neto >= minimo;
      var caja = raiz.querySelector('[data-minimo]');
      caja.classList.toggle('is-ok', ok);
      raiz.querySelector('[data-minimo-texto]').textContent = ok
        ? 'Pedido mínimo de ' + pesos(minimo) + ' neto cumplido'
        : hay
          ? 'Te faltan ' + pesos(minimo - neto) + ' neto para el pedido mínimo'
          : 'Pedido mínimo: ' + pesos(minimo) + ' neto';
      raiz.querySelector('[data-minimo-barra]').style.width = Math.min(100, Math.round((neto * 100) / minimo)) + '%';
      var pagar = raiz.querySelector('[data-pagar]');
      pagar.setAttribute('aria-disabled', ok ? 'false' : 'true');
      pagar.classList.toggle('is-listo', ok);
      raiz.querySelector('[data-otros]').hidden = !otros;
      var mayorista = raiz.querySelector('[data-mayorista]');
      if (mayorista) mayorista.hidden = neto < umbralMayorista;

      pintarSugerencia();
    }

    function leer() {
      return fetch(raizUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    }

    function enviar(url, cuerpo, lineas, accion) {
      if (ocupado) return;
      ocupado = true;
      raiz.classList.add('is-ocupado');
      fetch(raizUrl + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (e) {
              throw new Error(e.description || e.message || 'No se pudo actualizar tu pedido.');
            });
          }
          return r.json();
        })
        .then(leer)
        .then(function (c) {
          pintar(c);
          avisarAlTema(c, lineas, accion);
        })
        .catch(function (e) {
          window.alert(e.message);
        })
        .then(function () {
          ocupado = false;
          raiz.classList.remove('is-ocupado');
        });
    }

    function cambiar(id, cantidad, sumar) {
      if (sumar) {
        enviar('cart/add.js', { items: [{ id: parseInt(id, 10), quantity: cantidad }] }, [{ merchandiseId: String(id), quantity: cantidad }], 'add');
      } else {
        var u = {};
        u[id] = cantidad;
        enviar('cart/update.js', { updates: u }, [{ merchandiseId: String(id), quantity: cantidad }], cantidad === 0 ? 'remove' : 'update');
      }
    }

    function actualizar(updates) {
      var lineas = Object.keys(updates).map(function (id) {
        return { merchandiseId: String(id), quantity: updates[id] };
      });
      enviar('cart/update.js', { updates: updates }, lineas, 'update');
    }

    raiz.addEventListener('click', function (e) {
      var pagar = e.target.closest('[data-pagar]');
      if (pagar && pagar.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        var aviso = raiz.querySelector('[data-minimo]');
        aviso.classList.add('is-destacado');
        setTimeout(function () {
          aviso.classList.remove('is-destacado');
        }, 1200);
        return;
      }
      var it = e.target.closest('[data-item]');
      if (!it) return;
      var id = it.getAttribute('data-variante');
      var actual = carritoActual[id] || 0;
      if (e.target.closest('[data-agregar]')) cambiar(id, 1, true);
      if (e.target.closest('[data-mas]')) cambiar(id, actual + 1, false);
      if (e.target.closest('[data-menos]')) cambiar(id, Math.max(0, actual - 1), false);
    });

    // Avisa al ícono del carrito y al carrito lateral del tema (Horizon escucha shopify:cart:lines-update).
    function avisarAlTema(carrito, lineas, accion) {
      import('@shopify/events')
        .then(function (m) {
          var Evento = m.CartLinesUpdateEvent;
          var diferido = Evento.createPromise();
          raiz.dispatchEvent(new Evento({ action: accion, context: 'product', lines: lineas, promise: diferido.promise }));
          diferido.resolve({
            cart: Evento.createCartFromAjaxResponse(carrito),
            detail: { source: 'nt-tienda-pedido', itemCount: carrito.item_count, didError: false }
          });
        })
        .catch(function (e) {
          console.warn('[nt-tienda-pedido] No se pudo avisar al carrito del tema:', e);
        });
    }

    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.target === raiz || raiz.contains(e.target)) return;
      var listo = e.promise && typeof e.promise.then === 'function' ? e.promise : Promise.resolve();
      listo.then(leer).then(pintar).catch(function () {});
    });

    aplicarFiltros();
    pintarSugerencia();
    leer().then(pintar).catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();
})();
